import { DreiConfig } from "../../api";

export class MockDreiConfig implements DreiConfig {
  oauthConfig = {
    baseURL: "baseURL",
    clientID: "clientID",
    redirectURL: "redirectURL",
    scope: "scope",
  };
  crmConfig = { wrongCrmCustomerUrl: "wrongCrmCustomerUrl" };
  urlConfig = { infoUrl: "urlConfig" };
}
